import { ITelemetryItem } from "@microsoft/applicationinsights-web";

export abstract class TelemetryExclusionBase {
    protected telemetryItem: ITelemetryItem;

    constructor(telemetryItem: ITelemetryItem) {
        this.telemetryItem = telemetryItem;
    }

    public abstract isActive(): boolean;
}
